import { useMemo } from 'react';
import { Icon, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { infoNationality, tInfo } from './model';
import { FacialResultIconWrapper, InfoContainer } from './Styles';

type Props = {
  result?: boolean;
  loading?: boolean;
};

export const Nationality = ({ result, loading }: Props) => {
  const { t } = useTranslation();

  const info: tInfo = useMemo(() => {
    const type = result ? 'match' : 'notMatch';

    return infoNationality[type];
  }, [result]);

  return (
    <>
      {loading ? (
        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <Skeleton width="80%" height={18} borderRadius={8} />
        </div>
      ) : (
        <InfoContainer
          $infoBackground={info?.backgroundColor}
          $infoColor={info?.iconColor}
          rowGap="0.8"
          flexDirection="row"
          alignItems="center"
          key={`nationality-result`}
        >
          <FacialResultIconWrapper>
            <Icon
              iconName="ChatsCircle"
              color={info?.iconColor}
              size="32"
              weight="thin"
            />
          </FacialResultIconWrapper>
          <Label fontSize="12" semibold>
            {t(info?.message)}
          </Label>
        </InfoContainer>
      )}
    </>
  );
};
